import { DropDown } from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';
import useFetchNavCategories from '../../hooks/useFetchNavCategories';
import useTranslatedText from '../../hooks/useTranslatedText';
import style from './CategoryDropdown.module.scss';

const CategoryDropdown = ({
  currentCategoryId = '',
  parentCategoryId,
}) => {
  const { categoryOptions, defaultCategory, handleChange } = useFetchNavCategories({
    currentCategoryId,
    parentCategoryId,
  });

  const menuButtonCategory = useTranslatedText('menuButtonCategory', { fallback: 'Category' });

  return (
    <div className={style.wrapper} data-testid="category-dropdown">
      <DropDown
        id="grid-nav__sub-cat-dropdown"
        label={menuButtonCategory.value}
        onChange={handleChange}
        options={categoryOptions}
        value={defaultCategory?.value}
      />
    </div>
  );
};

CategoryDropdown.propTypes = {
  /** Category ID for the current page */
  currentCategoryId: PropTypes.string,
  /** Category ID used to generate dropdown options */
  parentCategoryId: PropTypes.string.isRequired,
};

export default CategoryDropdown;
